import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';

import { KEYS } from '../constants/service.constants';
import { Injectable } from '@angular/core';
import { map, catchError, tap } from 'rxjs/operators';
import { StorageSessionService } from '../../storage/services/storage.session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	doNotAddAuthTokenRequests: string[];
	addWithCredentialsRequests: string[];

	constructor(private storageSessionService: StorageSessionService) {
		this.doNotAddAuthTokenRequests = ['sppapi.spectrumreach.com/api/Payment', 'api_login'];
		this.addWithCredentialsRequests = ['frequence', 'brandcdn.com'];
	}

	intercept(req: HttpRequest<any>, next: HttpHandler) {
		const headers = req.headers;

		let addTokenAuth = true;
		this.doNotAddAuthTokenRequests.forEach((item) => {
			if (req.url.indexOf(item) > 0) {
				addTokenAuth = false;
			}
		});

		let addWithCredentialsFlag = false;
		this.addWithCredentialsRequests.forEach((item) => {
			if (req.url.indexOf(item) > 0) {
				addWithCredentialsFlag = true;
			}
		});

		const token = this.storageSessionService.token;
		let authReq: any = req.clone({
			headers: req.headers,
			withCredentials: addWithCredentialsFlag
		});
		if (addTokenAuth) {
			this.storageSessionService.checkSession();
			// Get the auth token from the service.
			if (token !== '' && !headers.get(KEYS.AUTH_TOKEN)) {
				authReq = req.clone({
					headers: req.headers.set(KEYS.AUTH_TOKEN, token),
					withCredentials: addWithCredentialsFlag
				});
			}
		}

		// send cloned request with header to the next handler.
		// send the newly created request
		return next.handle(authReq).pipe(
			tap((response) => {
				if (response instanceof HttpResponse) {
					// <-- HERE
					const responseHeaders: HttpHeaders = response.headers;
					if (responseHeaders.get(KEYS.AUTH_TOKEN)) {
						const authToken = responseHeaders.get(KEYS.AUTH_TOKEN);
						this.storageSessionService.setToken(
							KEYS.STORAGE_TOKEN_ID,
							KEYS.COOKIE_TOKEN_ID,
							authToken,
							KEYS.EXPIRES_IN
						);
						this.storageSessionService.checkSession();
					}
				}
			})
		);
	}
}
